import { ReactComponent as WarningFilled } from '../../../../assets/icons/warning-filled.svg';

export { WarningFilled };
